/**
 * Breadcrumb — Breadcrumb + page title, used at the top of every dashboard page.
 * Replaces the inline <nav className={styles.breadcrumb}>...</nav> markup that
 * was previously duplicated per-page (My Jobs, Support, Add Job/Gig, Company Profile).
 *
 * Props:
 *   crumbs   { label: string, href?: string }[]
 *            — last crumb is rendered as plain text (current page) even if it has an href
 *   title    string          — page <h1>
 *   actions  ReactNode       — optional right-aligned slot next to the title
 *                              (e.g. the "Add a new Job/Gig" button on My Jobs)
 *
 * Usage:
 *   <Breadcrumb
 *     crumbs={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'My Jobs', href: '/my-jobs' }, { label: 'Add New' }]}
 *     title="Add a New Job/Gig"
 *   />
 */
import { Fragment } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import styles from "./breadcrumb.module.css";
import { Link } from "react-router-dom";

export default function Breadcrumb({ crumbs = [], title, actions }) {
  const lastIdx = crumbs.length - 1;

  return (
    <div className={styles.pageHeader}>
      <nav className={styles.breadcrumb} aria-label="Breadcrumb">
        {crumbs.map((c, i) => (
          <Fragment key={c.label}>
            {i > 0 && <IconChevronRight size={12} />}
            {c.href && i !== lastIdx ? (
              <Link to={c.href}>{c.label}</Link>
            ) : (
              <span>{c.label}</span>
            )}
          </Fragment>
        ))}
      </nav>
      <div className={styles.pageTitleRow}>
        <h1 className={styles.pageTitle}>{title}</h1>
        {actions}
      </div>
    </div>
  );
}
